import { Injectable } from '@angular/core';
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';
import { environment } from '@examdojo/core/environment';

@Injectable({ providedIn: 'root' })
export class CustomerIoService {
  init() {
    if (!environment.customer_io.write_key) {
      return;
    }

    const inAppIntegrationConfig = environment.customer_io.site_id
      ? {
          'Customer.io In-App Plugin': {
            siteId: environment.customer_io.site_id,
          },
        }
      : {};

    AnalyticsBrowser.load(
      {
        cdnURL: 'https://cdp-eu.customer.io',
        writeKey: environment.customer_io.write_key,
      },
      {
        integrations: {
          ...inAppIntegrationConfig,
        },
      },
    );
  }
}
